import useHttpGet from 'states/generics/useHttpGet'
import useHttpPost from 'states/generics/useHttpPost'
import useState from 'states/generics/useState'
import { ref, computed } from '@vue/composition-api'

export default function useMessages() {
  const messagesResponse = ref(null)
  const [allMessages, setMessages] = useState([])
  const messages = computed(() => {
    return allMessages.value
  })
  const isMessagesFetchInProgress = ref(false)

  const fetchMessages = async ({ threadId }) => {
    if (isMessagesFetchInProgress.value) {
      console.warn(' => fetch is still in progress!')
      return
    }
    isMessagesFetchInProgress.value = true
    const url = `/chat/thread/${threadId}`
    const { get } = useHttpGet({ url, initialFetch: false })
    try {
      const response = await get()
      // messagesResponse.value = response
      // allMessages.value = messagesResponse.value.data.messages
      setMessages(response.data.messages)
      return messages.value
    } finally {
      isMessagesFetchInProgress.value = false
    }
  }

  const getMessageTs = (id) => {
    const msg = messages.value.filter((m) => m.id === id)[0]
    if (!msg) {
      throw new Error(`No message for id ${id}`)
    }
    return msg.ts
  }

  const markMessageAsRead = async ({ threadId, id }) => {
    console.log(' => markMessageAsRead()', id)
    const ts = getMessageTs(id)
    const newMessages = allMessages.value.map((m) => {
      return {
        ...m,
        already_read: m.already_read || m.ts <= ts,
      }
    })
    const url = `/chat/thread/${threadId}/read-until`
    const data = { message_id: id }
    const { post } = useHttpPost({ url })
    post(data)
    setMessages(newMessages)
  }

  return {
    messages,
    setMessages,
    isMessagesFetchInProgress,
    fetchMessages,

    markMessageAsRead,
  }
}
